import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-black`;
const Text = styled.div`
  ${tw`text-lg  text-black`}
  p {
    ${tw`mt-2 leading-loose text-black mb-56`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "RODO – Klauzula informacyjna" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>
              Przesłanie zapytania jest równoznaczne z wyrażeniem zgody na przetwarzanie danych osobowych. Administratorem danych osobowych jest DATAGRIT Sp. z o.o., ul. Plantowa 5/6, 05-830 Nadarzyn.
              <br></br><br></br>
              Dane osobowe będą przetwarzane wyłącznie w celu obsługi i realizacji przesłanego zapytania. Podstawą przetwarzania danych jest zgoda osoby, której dane dotyczą. Dane będą przechowywane do momentu wycofania zgody na ich przetwarzanie.
              <br></br><br></br>
              Osoba, której dane dotyczą, ma prawo do:<br></br>
                – dostępu do swoich danych,<br></br>
                – sprostowania danych,<br></br>
                – ograniczenia ich przetwarzania,<br></br>
                – wycofania zgody w dowolnym momencie,<br></br>
                – żądania trwałego usunięcia danych („prawo do bycia zapomnianym”).<br></br><br></br>

              Wszelkie dyspozycje dotyczące przetwarzania danych należy składać pisemnie lub mailowo bezpośrednio do Administratora. Administrator nie przewiduje wykorzystywania danych w celach innych niż te, dla których zostały one zebrane.
                <br></br><br></br>
              Podanie danych jest dobrowolne, jednak brak ich podania uniemożliwi realizację zapytania.
            </p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
